// https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
// This regex mirrors the behavior of most browser's email inputs. It's intentionally too permissive and not concerned
//   with spec compliance because email addresses are impossible to validate. We just want to filter out obviously
//   invalid values.
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
